import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { formatTextFloat } from '../../../helpers/Text';
import Icon2 from './icon/icon-pen-2';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './../reducer';
import { checkZerroInputValuationTool } from '../../../helpers/Text';
import './index.scss';
import Const from './Const';
import ConstVal from './../Const';
import HeaderMethod from './common/HeaderMethod';
import CalculateResult from './common/CalculateResult';
import InputError from './common/InputError';
import { parseIntComma } from '../helpers';

class PE extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: true,
      eoyStockPrice: '',
      ennOfNextYearStockPrice: '',

      estimatedEOY: 0,
      epsForecast: 0,
      estimatedEoyValidate: true,
      epsForecastValidate: true,
      estimatedEoyError: '',
      epsForecastError: '',

      infoError: '',
      organCode: props.valuationStock.organCode,
    };
    this.calculatePE.bind(this);
    this.estimatedEOY = React.createRef();
    this.epsForecast = React.createRef();
  }

  changeValueInput = (value, refInput) => {
    let infoError = '';
    if (value.length > 8) {
      return;
    }
    if (value.length > 0) {
      const parsedValue = parseIntComma(value);
      if (typeof parsedValue === 'number') {
        if (refInput === this.estimatedEOY) {
          this.setState({
            estimatedEOY: formatTextFloat(parseIntComma(value), 0),
          });
        } else {
          this.setState({
            epsForecast: formatTextFloat(parseIntComma(value), 0),
          });
        }

        return;
      }
      if (!value.match(/^[+-]?([0-9]+[.])?[0-9]+$/)) {
        if (refInput === this.estimatedEOY) {
          this.setState({
            estimatedEoyValidate: false,
            estimatedEoyError: Const.errorInput.inputCharacter,
            estimatedEOY: formatTextFloat(parseIntComma(value), 0),
            infoError,
            eoyStockPrice: '',
            ennOfNextYearStockPrice: '',
          });
        } else {
          this.setState({
            epsForecastValidate: false,
            epsForecastError: Const.errorInput.inputCharacter,
            epsForecast: formatTextFloat(parseIntComma(value), 0),
            infoError,
            eoyStockPrice: '',
            ennOfNextYearStockPrice: '',
          });
        }
        return;
      }
    }

    if (refInput === this.estimatedEOY) {
      this.setState({
        estimatedEOY: value ? formatTextFloat(parseIntComma(value), 0) : value,
        estimatedEoyValidate: true,
        estimatedEoyError: '',
      });
    } else {
      this.setState({
        epsForecast: value ? formatTextFloat(parseIntComma(value), 0) : value,
        epsForecastValidate: true,
        epsForecastError: '',
      });
    }
  };

  validatePE(estimatedEOY, epsForecast, peMultiple) {
    let infoError = '';
    if (estimatedEOY.length <= 0 || isNaN(estimatedEOY)) {
      infoError = 'valuation.errorPE.estimatedEOYError';
      this.setState({
        infoError,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
      });
    } else if (epsForecast.length <= 0 || isNaN(epsForecast)) {
      infoError = 'valuation.errorPE.epsForecastError';
      this.setState({
        infoError,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
      });
    } else if (peMultiple === null) {
      infoError = 'valuation.errorPE.peMultipleError';
      this.setState({
        infoError,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
      });
    } else {
      this.setState({ infoError: '' });
    }
    return infoError;
  }

  calculatePE = () => {
    const { averagePE } = this.props;

    const estimatedEOY = parseIntComma(this.estimatedEOY.current.value);
    const epsForecast = parseIntComma(this.epsForecast.current.value);
    const peMultiple = averagePE;

    let infoError = this.validatePE(estimatedEOY, epsForecast, peMultiple);
    if (infoError !== '') {
      return;
    }

    const eoyStockPrice = peMultiple * estimatedEOY;
    const ennOfNextYearStockPrice = peMultiple * epsForecast;
    this.setState({
      eoyStockPrice: formatTextFloat(eoyStockPrice).slice(0, -3),
      ennOfNextYearStockPrice: formatTextFloat(ennOfNextYearStockPrice).slice(
        0,
        -3,
      ),
      estimatedEOY: checkZerroInputValuationTool(estimatedEOY),
      epsForecast: checkZerroInputValuationTool(epsForecast),
    });
  };

  renderRowInfoMethod = (
    textFirst,
    textLast,
    refInput,
    stateInput,
    funtionOnChange,
    isValidate,
    isDisable,
    errorTooltip,
    isShowIconPopup = false,
  ) => {
    return (
      <div className="after-div-right" style={{ display: 'inherit' }}>
        <span>{textFirst}</span>
        {!isShowIconPopup ? (
          <>
            <div className="wrap-input-error">
              <input
                className="input-method"
                type="text"
                value={stateInput ? formatTextFloat(stateInput, 0) : stateInput}
                onChange={e => funtionOnChange(e.target.value, refInput)}
                ref={refInput}
                disabled={isDisable}
              />
              {isValidate && (
                <InputError message={I18n.t(`valuation.${errorTooltip}`)} />
              )}
            </div>
            <i
              className="icon-edit2 margin-icon"
              onClick={() => refInput.current.select()}
            />
            <span>{textLast}</span>
          </>
        ) : (
          <>
            <input
              className="input-method"
              type="number"
              value={stateInput}
              disabled
            />
            <div style={{ position: 'relative' }}>
              <Icon2 type={`P/E`} />
            </div>
          </>
        )}
      </div>
    );
  };

  renderCalculatorResult = () => {
    const {
      infoError,
      eoyStockPrice,
      ennOfNextYearStockPrice,
      estimatedEoyValidate,
      epsForecastValidate,
    } = this.state;

    const isValidate = !estimatedEoyValidate || !epsForecastValidate;

    return (
      <CalculateResult
        infoError={infoError}
        eoyStockPrice={eoyStockPrice}
        ennOfNextYearStockPrice={ennOfNextYearStockPrice}
        numOneFirstResult={'valuation.resultPE.numOneFirst'}
        numOneLastResult={'valuation.resultPE.numOneLast'}
        numTwoFirstResult={'valuation.resultPE.numTwoFirst'}
        numTwoLastResult={'valuation.resultPE.numTwoLast'}
        isValidate={isValidate}
        calculate={this.calculatePE}
      />
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.valuationStock.organCode !== this.state.organCode) {
      const valuationStock = nextProps.valuationStock;
      this.setState({
        ...this.state,
        estimatedEOY: valuationStock.estimatedEPS
          ? valuationStock.estimatedEPS
          : 0,
        epsForecast: valuationStock.forecastEPS
          ? valuationStock.forecastEPS
          : 0,
        organCode: nextProps.valuationStock.organCode,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
        infoError: '',
      });
    }
  }

  render() {
    const { averagePE, valuationStock } = this.props;
    const numOneFirstPE = I18n.t('valuation.methodPE.numOneFirst');
    const numOneLastPE = I18n.t('valuation.methodPE.numOneLast');
    const numTwoFirstPE = I18n.t('valuation.methodPE.numTwoFirst');
    const numTwoLastPE = I18n.t('valuation.methodPE.numbTwoLast');
    const numThreeFirstPE = I18n.t('valuation.methodPE.numThreeFirst');
    const numThreeLastPE = I18n.t('valuation.methodPE.numbThreeLast');
    const numFourPE = I18n.t('valuation.methodPE.numFour');

    let currentEPSFormatValue = formatTextFloat(valuationStock.rtd14, 0);
    const {
      estimatedEOY,
      epsForecast,
      estimatedEoyValidate,
      epsForecastValidate,
      estimatedEoyError,
      epsForecastError,
    } = this.state;

    return (
      <>
        <div className="right-method">
          <HeaderMethod
            title={'P/E'}
            keyRecommend={ConstVal.recommendMethod.pe}
            tooltipTitle={I18n.t('valuation.tooltipInfo.pe')}
          />
          <div className="after-div-right">
            <span>{numOneFirstPE}</span>
            <input
              className="input-method"
              disabled
              value={currentEPSFormatValue}
            />
            <span>{numOneLastPE}</span>
          </div>

          {this.renderRowInfoMethod(
            numTwoFirstPE,
            numTwoLastPE,
            this.estimatedEOY,
            estimatedEOY,
            this.changeValueInput,
            !estimatedEoyValidate,
            !epsForecastValidate,
            estimatedEoyError,
          )}
          {this.renderRowInfoMethod(
            numThreeFirstPE,
            numThreeLastPE,
            this.epsForecast,
            epsForecast,
            this.changeValueInput,
            !epsForecastValidate,
            !estimatedEoyValidate,
            epsForecastError,
          )}
          {this.renderRowInfoMethod(
            numFourPE,
            null,
            null,
            averagePE === null ? '' : averagePE,
            null,
            null,
            null,
            null,
            true,
          )}
        </div>

        {this.renderCalculatorResult()}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    averagePE: state[REDUCER_NAME].averagePE,
    i18n: state.i18n,
    valuationStock: state[REDUCER_NAME].valuationStock,
  };
};

export default connect(mapStateToProps)(PE);
